import { AppForm } from "@/shared/Components";
import type { UseFormReturn } from "react-hook-form";
import type { ModalProps } from "antd/lib";
import type { FC } from "react";
import { type AddTagModalFormValues } from "../schema";

interface Props extends ModalProps {
  onSubmit: (value: AddTagModalFormValues) => void;
  formApi: UseFormReturn<AddTagModalFormValues>;
}

export const Form: FC<Props> = ({ onSubmit, children, formApi }) => {
  const handleSubmit = (data: AddTagModalFormValues) => {
    onSubmit(data);
    formApi.reset();
  };

  return (
    <AppForm formApi={formApi} onSubmit={handleSubmit}>
      {children}
    </AppForm>
  );
};
